<template>
  <ButtonTooltip
    color="primary"
    :class="buttonClasses"
    small
    :tooltip-text="`${
      bookmarkStore.isPathBookmarked
        ? 'Remove from Bookmarks'
        : 'Add to Bookmarks'
    }`"
    :tooltip-props="{ 'nudge-bottom': 8 }"
    :icon-name="bookmarkStore.isPathBookmarked ? 'fa-bookmark' : 'fa-plus'"
    :button-text-right="
      bookmarkStore.isPathBookmarked ? 'Unbookmark' : 'Bookmark'
    "
    @click="bookmarkStore.toggleBookmarks"
  />
</template>

<script lang="ts">
import Vue from "vue"
import { mapStores } from "pinia"
import { useBookmarksStore } from "@/stores/bookmarks"
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip"

export default Vue.extend({
  name: "BookmarkButton",
  components: { ButtonTooltip },
  props: {
    buttonClasses: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapStores(useBookmarksStore),
  },
})
</script>
